/* =========================================================
   Sports n deco — Construit un data-map (format SNColPoster)
   à partir d'une sortie importée : coords [[lon,lat]…] + routes OSM.
   Port navigateur de scripts/cols/build-cols.mjs (projector/dp/tiers).
   API : SNColMap.build(coords, roadsElements, meta) -> mapData
   ========================================================= */
(function () {
  const PW = 800, PH = 1066, MX = 54, MT = 54, mapW = PW - 2 * MX, mapH = 650; // ratio 3:4
  const R = 6378137;
  const merc = (lon, lat) => [lon * Math.PI / 180 * R, Math.log(Math.tan(Math.PI / 4 + (lat * Math.PI / 180) / 2)) * R];

  function projector(coords) {
    let mnlo=180,mxlo=-180,mnla=90,mxla=-90;
    for (const [lo,la] of coords){ mnlo=Math.min(mnlo,lo);mxlo=Math.max(mxlo,lo);mnla=Math.min(mnla,la);mxla=Math.max(mxla,la); }
    const pdx=(mxlo-mnlo)*0.10, pdy=(mxla-mnla)*0.10;
    const [x0,y1m]=merc(mnlo-pdx,mxla+pdy),[x1,y0m]=merc(mxlo+pdx,mnla-pdy);
    const bw=x1-x0,bh=y1m-y0m, scale=Math.min(mapW/bw,mapH/bh);
    const ox=MX+(mapW-bw*scale)/2, oy=MT+(mapH-bh*scale)/2;
    return { proj:(lon,lat)=>{const[mx,my]=merc(lon,lat);return[ox+(mx-x0)*scale,oy+(y1m-my)*scale];},
             bbox:{S:mnla-pdy,W:mnlo-pdx,N:mxla+pdy,E:mxlo+pdx} };
  }

  function dp(pts, eps) {
    if (pts.length < 3) return pts;
    const sq=(a,b)=>{const dx=a[0]-b[0],dy=a[1]-b[1];return dx*dx+dy*dy;};
    const segDist=(p,a,b)=>{let x=a[0],y=a[1],dx=b[0]-x,dy=b[1]-y;
      if(dx||dy){const t=((p[0]-x)*dx+(p[1]-y)*dy)/(dx*dx+dy*dy);if(t>1){x=b[0];y=b[1];}else if(t>0){x+=dx*t;y+=dy*t;}}
      return sq(p,[x,y]);};
    const e2=eps*eps;
    const simplify=(f,l)=>{let maxD=0,idx=0;
      for(let i=f+1;i<l;i++){const d=segDist(pts[i],pts[f],pts[l]);if(d>maxD){maxD=d;idx=i;}}
      if(maxD>e2){const a=idx-f>1?simplify(f,idx):[pts[f]];const b=l-idx>1?simplify(idx,l):[pts[idx]];return a.concat(b);}
      return [pts[f]];};
    return simplify(0,pts.length-1).concat([pts[pts.length-1]]);
  }

  const TIER = {
    major:new Set(['motorway','trunk','primary']),
    medium:new Set(['secondary','tertiary','unclassified']),
    minor:new Set(['residential','living_street']),
  };
  function tierOf(hw){ for(const t in TIER) if(TIER[t].has(hw)) return t; return null; }

  /* meta : { name, side, region, country, km, dplus, pct, alt, lat, lon } */
  function build(coords, elements, meta) {
    const { proj } = projector(coords);
    const tiers = { major:[], medium:[], minor:[] };
    for (const w of (elements || [])) {
      const hw = w.tags && w.tags.highway; if (!hw || !w.geometry) continue;
      const t = tierOf(hw); if (!t) continue;
      const pts = dp(w.geometry.map(g => proj(g.lon, g.lat)), 0.6);
      if (pts.length < 2) continue;
      tiers[t].push('M' + pts.map(p => p[0].toFixed(1) + ' ' + p[1].toFixed(1)).join(' L'));
    }
    const tp = coords.map(c => proj(c[0], c[1]));
    const [sx,sy] = tp[0], [ex,ey] = tp[tp.length-1];
    return {
      viewBox:[PW,PH], map:[MX,MT,mapW,mapH],
      track:'M'+tp.map(p=>p[0].toFixed(1)+' '+p[1].toFixed(1)).join(' L'),
      roads:{ major:tiers.major.join(' '), medium:tiers.medium.join(' '), minor:tiers.minor.join(' ') },
      start:[+sx.toFixed(1),+sy.toFixed(1)], end:[+ex.toFixed(1),+ey.toFixed(1)],
      col: meta,
    };
  }

  // expose aussi le projector pour calculer la bbox (fetch Overpass)
  window.SNColMap = { build, bboxOf: (coords) => projector(coords).bbox };
})();
